/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VoucherProduct,
    VoucherProductFromJSON,
    VoucherProductFromJSONTyped,
    VoucherProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface VoucherProductDataFrame
 */
export interface VoucherProductDataFrame {
    /**
     * 
     * @type {number}
     * @memberof VoucherProductDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherProductDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherProductDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<VoucherProduct>}
     * @memberof VoucherProductDataFrame
     */
    data: Array<VoucherProduct>;
}

export function VoucherProductDataFrameFromJSON(json: any): VoucherProductDataFrame {
    return VoucherProductDataFrameFromJSONTyped(json, false);
}

export function VoucherProductDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherProductDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(VoucherProductFromJSON)),
    };
}

export function VoucherProductDataFrameToJSON(value?: VoucherProductDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(VoucherProductToJSON)),
    };
}


